import MainImage from '../voluntary-template/icons/VoluntaryHealth.png';
import VectorFirst from '../voluntary-template/icons/box/shield.svg';
import VectirSecond from '../voluntary-template/icons/box/clinical_notes.svg';
import VectorThird from '../voluntary-template/icons/box/portfolio.svg';
import Checkbox from '../voluntary-template/icons/Checkbox.svg';
import Thunder from '../voluntary-template/icons/Thunder.svg';
import Contract from '../voluntary-template/icons/VoluntaryHealthGPO.png';
import Shield from '../voluntary-template/icons/Shield.png';
import Star from '../voluntary-template/icons/Star.png';
import Pyramid from '../voluntary-template/icons/pyramid.png';
import People from '../voluntary-template/icons/people.png';
import Box from '../voluntary-template/icons/Box.png';

const voluntaryHealthResources = {
  en: {
    voluntaryHealth: {
      title: 'Health Insurance',
      description:
        'Financial protection in case of illness, including serious and critical diagnoses. The insurance payout helps cover treatment expenses, support the family, and maintain the usual standard of living during temporary disability.',
      buttonText: 'Submit Application',
      infoCards: [
        {
          title: 'Financial Stability',
          content:
            'Payment in a lump sum or in installments — upon occurrence of an insured event.',
        },
        {
          title: 'Protection from Critical Illnesses',
          content:
            'Includes an extensive list of critical diseases: cancer, heart attack, stroke, and more.',
        },
        {
          title: 'Suitable for Individuals and Companies',
          content: 'Can insure both employees and individual family members.',
        },
      ],
      coverage: [
        {
          title: 'What We Cover',
          content: [
            'Risks of temporary disability',
            'Diagnosis of critical illnesses',
            'Loss of ability to work due to illness',
          ],
        },
        {
          title: 'Covered Risks',
          content: [
            'Cancer',
            'Cardiovascular diseases (heart attack, stroke, etc.)',
            'Major surgical interventions',
            'Other illnesses specified in the contract',
          ],
        },
        {
          title: 'Illustration',
          content: [],
        },
      ],
      featureCards: [
        {
          title: 'Insurance Amount',
          content:
            "Determined individually, based on the client's age, health status, and needs.",
        },
        {
          title: 'Duration',
          content: 'From 6 months to 1 year and more — by agreement.',
        },
        {
          title: 'Territory of Coverage',
          content:
            'Republic of Kazakhstan. Possibility of treatment in other countries — by agreement.',
        },
      ],
      formTitle: 'Insurance Application',
      formDescription:
        'Please be sure to provide the company name, BIN, and contact phone number.',
      formCheckBox1: 'I confirm',
      formCheckBox2:
        'my consent to the collection and processing of personal data',
      formPlaceholder1: 'Company',
      formPlaceholder2: 'BIN',
      formPlaceholder3: 'Full Name',
      formPlaceholder4: 'Phone',
      formPlaceholder5: 'Email',
      formPlaceholder6: 'Comment',
      formButtonText: 'Submit Application',
      formSuccessStatus: 'Your application has been submitted successfully.',
      formErrorStatus: 'Failed to submit the application.',
      formErrorMessage:
        'Please try submitting the application again in 4 hours.',
      formSendClose: 'Close',
      trustTitle: 'Why clients trust Alatau City Garant',
      trustCards: {
        first: [
          {
            id: 1,
            title: '17 years',
            content: 'on the insurance market of Kazakhstan',
          },
          {
            id: 2,
            title: 'TOP 2',
            content: 'by volume of insurance payouts',
          },
          {
            id: 3,
            title: 'kzA-',
            content: 'financial stability rating by S&P Global Ratings',
          },
          {
            id: 4,
            title: '600+',
            content: 'employees working across the country',
          },
        ],
        second: [
          {
            id: 5,
            title: '₸59.4 billion',
            content: 'insurance premiums collected in 2024',
          },
          {
            id: 6,
            title: '₸22 billion',
            content: 'insurance payouts made in 2024',
          },
        ],
        third: '(According to the National Bank of Kazakhstan, Jan–Feb 2025)',
      },
    },
  },
  kz: {
    voluntaryHealth: {
      title: 'Ауырған жағдайда сақтандыру',
      description:
        'Сақтандырылушыларға ыңғайлы жағдайда уақтылы, сапалы медициналық қызметтерді алуға мүмкіндік береді.',
      buttonText: 'Өтініш беру',
      infoCards: [
        {
          title: 'Сақтандыру не үшін қажет',
          content:
            'Денсаулық жай-күйі қиындаған жағдайда, қаржылық қорғауды қамтамасыз етеді, сонымен қатар сырқаттану сәтінен бастап толық қалпына келгенге дейін толық сүйемелдеу қызметін алуға мүмкіндік береді.',
        },
        {
          title: 'Дербес талаптар',
          content:
            'Сақтандыру талаптары таңдалған бағдарламаларға байланысты әр клиент бойынша дербес белгіленеді.',
        },
        {
          title: 'Сенімділікті арттыру',
          content:
            'Медициналық сақтандыру бойынша клиенттерге қызмет көрсету белгілі медициналық ассистанстар арқылы жүзеге асырылады.',
        },
      ],
      coverage: [
        {
          title: 'Нені сақтандырамыз',
          content: [
            'Сақтанушының /Сақтандырылушының сырқаттануына және денсаулығының өзге де бұзылуына байланысты шығыстарды ішінара немесе толық өтеуге байланысты мүліктік мүдделері.',
          ],
        },
        {
          title: 'Қандай тәуекелдерден',
          content: [
            'Сақтандырылушының медициналық және өзге де қызметтерге жүгінуі және осыған байланысты сақтандырылушының сырқаттануы немесе сақтандырылушының ағзасы функцияларының өзге де бұзылуы салдарынан туындаған шығыстарының орын алуы сақтандыру жағдайы деп танылады.',
          ],
        },
        {
          title: 'Иллюстрация',
          content: [],
        },
      ],
      featureCards: [
        {
          title: 'Сақтандыру сомасы',
          content: 'Клиенттің қажеттіліктерін ескере отырып, жеке белгіленеді.',
        },
        {
          title: 'Қолданыс мерзімі',
          content: '12 ай, сондай-ақ Тараптардың келісімі бойынша.',
        },
        {
          title: 'Сақтандыру аумағы',
          content: 'Қазақстан Республикасы.',
        },
      ],
      formTitle: 'Өтінім қалдыру',
      formDescription: 'БСН және байланыс телефонын көрсетуді ұмытпаңыз.',
      formCheckBox1: 'Мен',
      formCheckBox2:
        'жеке деректерімді жинауға және өңдеуге келісімімді растаймын',
      formPlaceholder1: 'Компания',
      formPlaceholder2: 'БСН',
      formPlaceholder3: 'ФИО',
      formPlaceholder4: 'Телефон',
      formPlaceholder5: 'Эл.пошта',
      formPlaceholder6: 'Түсініктеме',
      formButtonText: 'Жөнелту',
      formSuccessStatus: 'Сіздің өтінішіңіз сәтті жіберілді.',
      formErrorStatus: 'Өтінішті жіберу сәтсіз аяқталды.',
      formErrorMessage: 'Өтінішті 4 сағаттан кейін жіберіп көріңіз.',
      formSendClose: 'Жабу',
      trustTitle: 'Неліктен клиенттер Alatau City Garant-қа сенім артады',
      trustCards: {
        first: [
          {
            id: 1,
            title: '17 жыл',
            content: 'Қазақстанның сақтандыру нарығында қызмет еткеніне',
          },
          {
            id: 2,
            title: '3 орын',
            content:
              '2024 жылы ҚР жалпы сақтандыру компаниялары арасында сақтандыру төлемдерінің көлемі бойынша',
          },
          {
            id: 3,
            title: 'ВВ-Болжам «Тұрақты»',
            content: 'S&P Global Ratings қаржылық тұрақтылық рейтингі',
          },
          {
            id: 4,
            title: '22 филиал',
            content: 'Alatau City Garant бүкіл ел аумағында жұмыс істейді',
          },
        ],
        second: [
          {
            id: 5,
            title: '39,3 млрд ₸',
            content:
              'сақтандыру сыйлықақыларын Alatau City Garant 2024 жылы жинады',
          },
          {
            id: 6,
            title: '25,5 млрд ₸ ',
            content: 'Alatau City Garant 2024 жылы клиенттерге төледі',
          },
        ],
        third: '(ҚР Ұлттық Банкінің деректері бойынша)',
      },
      businessDescription:
        'Ауру жағдайында, оның ішінде ауыр және қатерлі диагноздар қойылғанда қаржылық қорғау.',
    },
  },
  ru: {
    voluntaryHealth: {
      title: 'Страхование на случай болезни',
      description:
        'Позволяет застрахованным получать своевременные, качественные медицинские услуги в комфортных условиях.',
      buttonText: 'Отправить заявку',
      infoCards: [
        {
          title: 'Для чего нужна страховка',
          content:
            'Предоставляет финансовую защиту в случае наступления расстройства здоровья, но и позволяет получать полный сервис сопровождения с момента заболевания до полного выздоровления.',
        },
        {
          title: 'Персональные условия',
          content:
            'Условия страхования устанавливаются по каждому клиенту индивидуально, в зависимости от выбранных программ.',
        },
        {
          title: 'Повышение доверия',
          content:
            'Обслуживание клиентов по страхованию на случай болезни  осуществляется через известные медицинские ассистансы.',
        },
      ],
      coverage: [
        {
          title: 'Что страхуем',
          content: [
            'Имущественные интересы Страхователя /Застрахованного, связанные с частичной или полной компенсацией расходов в связи с заболеванием и иным расстройствам здоровья.',
          ],
        },
        {
          title: 'От каких рисков',
          content: [
            'Страховым случаем признается обращение застрахованного за медицинскими и иными услугами, и связанное с этим возникновение расходов застрахованного, возникших вследствие заболевания или иного расстройства функций организма застрахованного.',
          ],
        },
        {
          title: 'Иллюстрация',
          content: [],
        },
      ],
      featureCards: [
        {
          title: 'Страховая сумма',
          content:
            'Устанавливается индивидуально, с учетом потребностей клиента.',
        },
        {
          title: 'Срок действия',
          content: '12 месяцев, а также по соглашению сторон.',
        },
        {
          title: 'Территория страхования',
          content: 'Республика Казахстан.',
        },
      ],
      formTitle: 'Заявка на страхование',
      formDescription:
        'Пожалуйста, обязательно укажите БИН и контактный телефон.',
      formCheckBox1: 'Я подтверждаю ',
      formCheckBox2: 'согласие на сбор и обработку персональных данных',
      formPlaceholder1: 'Компания',
      formPlaceholder2: 'БИН',
      formPlaceholder3: 'ФИО',
      formPlaceholder4: 'Телефон',
      formPlaceholder5: 'Эл.почта',
      formPlaceholder6: 'Комментарий',
      formButtonText: 'Отправить заявку',
      formSuccessStatus: 'Спасибо! Ваша заявка отправлена',
      formErrorStatus: 'Не удалось отправить заявку',
      formErrorMessage: 'Попробуйте отправить заявку через 4 часа.',
      formSendClose: 'Закрыть',
      trustTitle: 'Почему клиенты доверяют Alatau City Garant',
      trustCards: {
        first: [
          {
            id: 1,
            title: '17 лет',
            content: 'на страховом рынке Казахстана',
          },
          {
            id: 2,
            title: '3 место',
            content:
              'по объему страховых выплат среди компаний общего страхования РК в 2024 году',
          },
          {
            id: 3,
            title: 'ВВ-прогноз «Стабильный»',
            content: 'рейтинг финансовой устойчивости от S&P Global Ratings',
          },
          {
            id: 4,
            title: '22 филиала',
            content: 'Alatau City Garant работают по всей стране ',
          },
        ],
        second: [
          {
            id: 5,
            title: '39,3 млрд ₸',
            content: 'страховых премий собрал Alatau City Garant в 2024 году',
          },
          {
            id: 6,
            title: '25,5 млрд ₸ ',
            content: 'выплатил Alatau City Garant клиентам в 2024 году ',
          },
        ],
        third: '(по данным Нацбанка РК)',
      },
      businessDescription:
        'Финансовая защита при наступлении болезни, включая тяжёлые и критические диагнозы.',
    },
  },
  mainCard: {
    image: MainImage,
  },
  infoCards: [
    {
      id: 1,
      image: VectorFirst,
    },
    {
      id: 2,
      image: VectirSecond,
    },
    {
      id: 3,
      image: VectorThird,
    },
  ],
  coverage: [
    {
      title: 'Что страхуем?',
      content: [
        'Имущественные интересы Страхователя /Застрахованного, связанные с частичной или полной компенсацией расходов в связи с заболеванием и иным расстройствам здоровья.',
      ],
      image: Checkbox,
    },
    {
      title: 'От каких рисков?',
      content: [
        'Страховым случаем признается обращение застрахованного за медицинскими и иными услугами, и связанное с этим возникновение расходов застрахованного, возникших вследствие заболевания или иного расстройства функций организма застрахованного. ',
      ],
      image: Thunder,
    },
    {
      title: 'Иллюстрация',
      content: [],
      image: Contract,
    },
  ],
  featureCards: [
    {
      title: 'Страховая сумма',
      content:
        'Устанавливается индивидуально, с учётом возраста, состояния здоровья и потребностей клиента.',
    },
    {
      title: 'Срок действия',
      content: 'От 6 месяцев до 1 года и более — по согласованию.',
    },
    {
      title: 'Территория действия',
      content:
        'Республика Казахстан. Возможность лечения в других странах — по согласованию.',
    },
  ],
  trustCards: {
    first: [
      {
        id: 1,
        title: '17 лет',
        content: 'на страховом рынке Казахстана',
        image: Shield,
      },
      {
        id: 2,
        title: 'ТОП 2',
        content: 'по объёму страховых выплат ',
        image: Star,
      },
      {
        id: 3,
        title: 'kzA-',
        content: 'рейтинг финансовой устойчивости от S&P Global Ratings',
        image: Pyramid,
      },
      {
        id: 4,
        title: '600+',
        content: 'сотрудников работают по всей стране',
        image: People,
      },
    ],
    second: [
      {
        title: '59,4 млрд ₸',
        content: 'страховых премий собрано за 2024 год ',
      },
      {
        title: '22 млрд ₸',
        content: 'выплачено по страховым случаям за 2024 год',
      },
    ],
    image: Box,
  },
};

export default voluntaryHealthResources;
